import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SessionService } from '@domain/application/observable-services/session.service';
import {
  appendOutsideTaxForm,
  createOutsideTaxForm,
  forceAffirmativeValidation,
} from '@modules/business-accounts/forms/outside-tax/outside-tax.form';
import { IBaseFormBuilder } from '../../../builders/base-builder.class';
import { EMAIL_VALIDATOR } from '../../../common-fields/email.field';

export class NaturalPersonDataClientFormBuilder implements IBaseFormBuilder {
  private form: FormGroup;

  constructor(private readonly sessionService: SessionService, private initialValues?: any) {
    this.form = new FormGroup({});
  }

  public build() {
    const { personType } = this.sessionService.getCommonInfoValue;
    if (personType == undefined) this.addTaxResidenceForm();
    this.addPersonalFields();
    this.addSectorFields();
  }

  public getResult(): FormGroup {
    return this.form;
  }

  private initialValue(fieldName: string) {
    return this.initialValues[fieldName] || null;
  }

  private addTaxResidenceForm(): this {
    appendOutsideTaxForm({
      to: this.form,
      with: createOutsideTaxForm({
        isTaxOutsideValidators: [forceAffirmativeValidation],
      }),
      // with: createOutsideTaxForm(),
    });
    return this;
  }

  private addPersonalFields() {
    this.form.addControl(
      'personalData',
      new FormGroup({
        ruc: new FormControl(this.initialValue('ruc'), [
          Validators.required,
          Validators.pattern(/^10/),
          Validators.minLength(11),
        ]),
        phoneNumber: new FormControl(this.initialValue('phoneNumber'), [Validators.required, Validators.pattern(/^9/), Validators.minLength(9)]),
        phoneCarrier: new FormControl(this.initialValue('phoneCarrier'), [Validators.required]),
        businessName: new FormControl('', Validators.required),
        email: new FormControl(this.initialValue('email'), EMAIL_VALIDATOR),
        isPEP: new FormControl(false, [Validators.required]),
      })
    );
  }

  private addSectorFields() {
    this.form.addControl(
      'sectorData',
      new FormGroup({
        sectorCode: new FormControl(null, [Validators.required]),
        subSectorCode: new FormControl(null, []),
      })
    );
  }
}

export const getPersonalDataClientFormInstance = ({ from: form }: { from: FormGroup }) =>
  form.get('personalData') as FormGroup;

export const getSectorDataClientFormInstance = ({ from: form }: { from: FormGroup }) =>
  form.get('sectorData') as FormGroup;
